import type { OrderCompanyBillMetadata } from "../../redux/constants/OrdersPage/order";
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { UserOptions } from "jspdf-autotable";
import { defaults, compact } from "lodash";
import { LatLngLiteral } from "leaflet";
import { TFunction, t } from "i18next";

import {
	ExecuteOrderStage,
	IOrderPoint,
	OrderPaymentStatus,
	getOrderPassengerPoints,
} from "../../redux/constants/OrdersPage/order";
import SubscriptionPool from "../../redux/services/SubscriptionPool";
import { store } from "../../redux/store";
import { getPRPC } from "../../hooks/usePRPC";
import createRPCQuery from "../../utils/createRPCQuery.util";
import { decompressRoute } from "../../utils/decompressRoute.util";
import {
	generateFileNameFileHelper,
	createLogger,
	getExcelCurrencyFormat,
} from "../../utils";
import {
	recordFromResponse,
	recordHydrate,
	recordWsEvents,
} from "../../utils/frontendPerf";
import { SortingOrder } from "../../types/SortingOrder";
import {
	OrderExecutingStage,
	OrderSource,
	Subscription,
	Passanger,
	OrderStatus,
	Customer,
	ServiceSubscribeOptionsBase,
} from "../../types";
import {
	CURRENCY_SUFFIXES,
	getCurrencySymbol,
} from "../../types/СurrencyDefinitions";
import { MessageTemplateActions } from "../../types/MessageTemplateEnums";
import { ModelId } from "../../types/ModelId";
import {
	OrderCostRequest,
	OrderCostResponse,
} from "../../pages/MainPage/pages/Orders/components/OrderModal/hooks/useCalcOrderCost";
import { Language, ValueLanguage } from "../../assets/languages/langs";
import { CalendarNamespace } from "../../components/common";
import { ColumnId } from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/columns";
import { ReceiptSummary } from "../ReceiptProvider/types";
//
import additionalPhoneCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/AdditionalPhoneCellContent/cellProcessing";
import carClassCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/CarClassCellContent/cellProcessing";
import closeReasonCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/CloseReasonCellContent/cellProcessing";
import clientRefusalReasonCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ClientRefusalReasonCellContent/cellProcessing";
import companyCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/CompanyCellContent/cellProcessing";
import counterpartyCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/CounterpartyCellContent/cellProcessing";
import counterpartyCheckCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/CounterpartyCheckContent/cellProcessing";
import counterpartyCheckCardCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/CounterpartyCheckCardContent/cellProcessing";
import createOrderDateCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/CreateOrderDateCellContent/cellProcessing";
import createOrderTimeCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/CreateOrderTimeCellContent/cellProcessing";
import customerCallStatusCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/CustomerCallStatusCellContent/cellProcessing";
import customerFullNameCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/CustomerFullNameCellContent/cellProcessing";
import customerNoteCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/CustomerNoteCellContent/cellProcessing";
import destinationAddressCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/DestinationAddressCellContent/cellProcessing";
import destinationSectorCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/DestinationSectorCellContent/cellProcessing";
import destinationSettlementCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/DestinationSettlementCellContent/cellProcessing";
import discountCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/DiscountCellContent/cellProcessing";
import dispatcherCallSignCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/DispatcherCallSignCellContent/cellProcessing";
import executingStageCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ExecutingStageCellContent/cellProcessing";
import executingStageAcceptedTimeCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ExecutingStageAcceptedTimeCellContent/cellProcessing";
import executingStageArrivedTimeCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ExecutingStageArrivedTimeCellContent/cellProcessing";
import executingStageWaitingCustomerTimeCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ExecutingStageWaitingCustomerTimeCellContent/cellProcessing";
import executingStageWithClientsTimeCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ExecutingStageWithClientsTimeCellContent/cellProcessing";
import executorArrivalDateCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ExecutorArrivalDateCellContent/cellProcessing";
import executorArrivalTimeCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ExecutorArrivalTimeCellContent/cellProcessing";
import executorCallSignCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ExecutorCallSignCellContent/cellProcessing";
import executorCallStatusCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ExecutorCallStatusCellContent/cellProcessing";
import executorLateCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ExecutorLateCellContent/cellProcessing";
import executorNoteCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ExecutorNoteCellContent/cellProcessing";
import idleTimeCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/IdleTimeCellContent/cellProcessing";
import orderDateCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/OrderDateCellContent/cellProcessing";
import orderNumberCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/OrderNumberCellContent/cellProcessing";
import orderPriceCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/OrderPriceCellContent/cellProcessing";
import orderTimeCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/OrderTimeCellContent/cellProcessing";
import parkLineCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ParkLineCellContent/cellProcessing";
import parametersCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ParametersCellContent/cellProcessing";
import paymentTypeCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/PaymentTypeCellContent/cellProcessing";
import paymentStatusCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/PaymentStatusCellContent/cellProcessing";
import phoneCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/PhoneCellContent/cellProcessing";
import pickupAddressCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/PickupAddressCellContent/cellProcessing";
import pickupSectorCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/PickupSectorCellContent/cellProcessing";
import pickupSettlementCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/PickupSettlementCellContent/cellProcessing";
import rideNumberCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/RideNumberCellContent/cellProcessing";
import receiptStatusCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ReceiptStatusCellContent/cellProcessing";
import servicesCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ServicesCellContent/cellProcessing";
import smsStatusCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/SMSStatusCellContent/cellProcessing";
import statusCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/StatusCellContent/cellProcessing";
import sourceCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/SourceCellContent/cellProcessing";
import sourceCallSignCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/SourceCallSingCellContent/cellProcessing";
import tariffCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/TariffCellContent/cellProcessing";
import taxiServiceCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/TaxiServiceCellContent/cellProcessing";
import totalRideCountCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/TotalRideCountCellContent/cellProcessing";
import transferFromTaxiServiceCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/TransferFromTaxiServiceCellContent/cellProcessing";
import transferToTaxiServiceCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/TransferToTaxiServiceCellContent/cellProcessing";
import transportationTypeCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/TransportationTypeCellContent/cellProcessing";
import closedTimeCellProcessing from "../../components/OrderPageWidgets/OrderTable/components/ModelTable/components/ClosedTimeCellContent/cellProcessing";
import { ModelEventConstructor } from "../../utils/ModelEventConstructor";
import { createStaleWatchdog } from "../../utils/ordersStaleWatchdog";
import {
	createHydrateCoordinator,
	splitOrderEvents,
} from "../../utils/ordersHydrate";
import { primeOfferDeadline } from "../../utils/ordersHotPath";
import OrderSettingNameSpace from "../../pages/Settings/pages/Orders/tabs/Orders/components/Modal/components/Content";
import { ResGetGPSHistory } from "../../redux/services/Archives/GPSLog/locations";
//
import { MoveToProgressType } from "../OrderSettings";
import { Base, Currency, Agent } from "..";
// src\pages\Settings\pages\Orders\tabs\Orders\components\Modal\components\Content\index.tsx

import type { DateFns } from "../../utils/DateFns";
import type { ColorState } from "../../redux/reducers/settings/colors";

export interface OrderForm {
	orderId: number;
	/** this orderFormTab.form as `JSON.stringify` */
	form: string | null;
}

export enum OrderReminderStatus {
	/** green */
	START = "start",
	/** orange */
	SEND = "send",
	/** green */
	SUCCESS = "success",
	/** red */
	FAILED = "failed",
}

/**
 * Order type determines the way the order will be processed.
 */
export enum OrderType {
	/*
	 * The default order type means that the passenger will pay for the order themselves.
	 */
	DEFAULT = "default",

	/**
	 * The wizard order type means that everything in the order can be changed without any restrictions
	 */
	WIZARD = "wizard",

	/**
	 * The sponsored order type means that the order will be paid by another person (customer).
	 */
	CUSTOMER_SPONSORED = "customer_sponsored",
}

const logger = createLogger({ name: "Order" });

const CHECK_BALANCE_TIMEOUT_MS = 2000;

function getCurrencyFromGlobal() {
	const additionalTariff = store.getState().additionalTariffs?.models?.[0];
	const displayStyle =
		additionalTariff?.additionalFields?.general?.currency?.displayStyle ??
		"name";
	return additionalTariff?.currency?.settings?.[displayStyle] ?? "";
}

class Order extends Base {
	static defaultSharedOptions: Order.SharedOptions = {
		deprecate: true,
	};

	static fromResponse(
		item: any,
		mapOptions?: { skipCellsForTable?: boolean },
	): Order.Model | undefined {
		try {
			if (item === undefined) {
				throw new Error("Order.fromResponse: item is undefined");
			}

			const { colors, order: orderSettings } = store.getState().settings;
			const lang = store.getState().session.language;

			const skipCells = Boolean(mapOptions?.skipCellsForTable);

			const cellsForTableSettings: Order.CellsForTableSettings = {
				isCellsReady: !skipCells,
				colors,
				lang,
				orderSettings,
			};

			const cellsForTable: Order.CellsForTable | undefined = skipCells
				? undefined
				: {
						// * --- Static Cells ---
						[ColumnId.ExecutorCallSign]:
							executorCallSignCellProcessing(item) ?? null,
						[ColumnId.PickupSettlement]:
							pickupSettlementCellProcessing(item) ?? null,
						[ColumnId.CustomerCallStatus]:
							customerCallStatusCellProcessing(item) ?? null,
						[ColumnId.ExecutorCallStatus]:
							executorCallStatusCellProcessing(item) ?? null,
						[ColumnId.OrderNumber]:
							orderNumberCellProcessing(item.orderNumber) ?? null,
						[ColumnId.CustomerNote]:
							customerNoteCellProcessing(item) ?? null,
						[ColumnId.DestinationSettlement]:
							destinationSettlementCellProcessing(item) ?? null,
						[ColumnId.ExecutorNote]:
							executorNoteCellProcessing(item) ?? null,
						[ColumnId.AdditionalPhone]:
							additionalPhoneCellProcessing(item.phones) ?? null,
						[ColumnId.SourceCallSing]:
							sourceCallSignCellProcessing(item, t) ?? null,
						[ColumnId.RideNumber]:
							rideNumberCellProcessing(item.passengers) ?? null,
						[ColumnId.TotalRideCount]:
							totalRideCountCellProcessing(item.passengers) ??
							null,
						[ColumnId.CustomerFullName]:
							customerFullNameCellProcessing(item) ?? null,
						[ColumnId.Counterparty]:
							counterpartyCellProcessing(item.counterparty) ??
							null,
						[ColumnId.CounterpartyCheck]:
							counterpartyCheckCellProcessing(item.checkCard) ??
							null,
						[ColumnId.CounterpartyCheckCard]:
							counterpartyCheckCardCellProcessing(
								item.checkCard,
							) ?? null,
						[ColumnId.ExecutorLate]:
							executorLateCellProcessing(item.executingStages) ??
							null,
						[ColumnId.ParkLine]:
							parkLineCellProcessing(item.park_line) ?? null,

						// * --- Dynamic Cells (colors) ---
						[ColumnId.OrderPrice]:
							orderPriceCellProcessing(
								item,
								colors,
								getCurrencyFromGlobal(),
							) ?? null,

						// * --- Dynamic Cells ( orderSettings ) ---
						[ColumnId.Phone]:
							phoneCellProcessing(item, orderSettings) ?? null,

						// * --- Dynamic Cells (lang) ---
						[ColumnId.PickupSector]:
							pickupSectorCellProcessing(item, lang) ?? null,
						[ColumnId.TransferFromTaxiService]:
							transferFromTaxiServiceCellProcessing(item, lang) ??
							null,
						[ColumnId.TransferToTaxiService]:
							transferToTaxiServiceCellProcessing(item, lang) ??
							null,
						[ColumnId.CarClass]:
							carClassCellProcessing(
								item.orderToCarClasses,
								lang,
							) ?? null,
						[ColumnId.DestinationSector]:
							destinationSectorCellProcessing(item, lang) ?? null,
						[ColumnId.Company]:
							companyCellProcessing(item.taxiService, lang) ??
							null,
						[ColumnId.TaxiService]:
							taxiServiceCellProcessing(item.taxiService, lang) ??
							null,
						[ColumnId.Tariff]:
							tariffCellProcessing(item.rate, lang) ?? null,
						[ColumnId.Services]:
							servicesCellProcessing(
								item.orderToServices,
								lang,
							) ?? null,
						[ColumnId.Discount]:
							discountCellProcessing(item, lang) ?? null,

						// * --- Dynamic Cells ( lang to t ) ---
						[ColumnId.PickupAddress]:
							pickupAddressCellProcessing(item, t) ?? null,
						[ColumnId.DestinationAddress]:
							destinationAddressCellProcessing(item, t) ?? null,
						[ColumnId.PaymentType]:
							paymentTypeCellProcessing(item, t) ?? null,
						[ColumnId.PaymentStatus]:
							paymentStatusCellProcessing(item, t, colors) ??
							null,
						[ColumnId.DispatcherCallSign]:
							dispatcherCallSignCellProcessing(
								item.closedOrderComments,
								t,
							) ?? null,
						[ColumnId.Parameters]:
							parametersCellProcessing(
								item.additionalFields,
								t,
							) ?? null,
						[ColumnId.ExecutingStage]:
							executingStageCellProcessing(
								item.executingStage,
								t,
							) ?? null,
						[ColumnId.CloseReason]:
							closeReasonCellProcessing(item, t) ?? null,
						[ColumnId.ClientRefusalReason]:
							clientRefusalReasonCellProcessing(item, lang, t) ??
							null,
						[ColumnId.SMSLateStatus]:
							smsStatusCellProcessing(
								item.smsMessages,
								MessageTemplateActions.LATE,
								t,
							) ?? null,
						[ColumnId.SMSWillBeAtStatus]:
							smsStatusCellProcessing(
								item.smsMessages,
								MessageTemplateActions.WILL_BE_TIME,
								t,
							) ?? null,
						[ColumnId.SMSCarNotFoundStatus]:
							smsStatusCellProcessing(
								item.smsMessages,
								MessageTemplateActions.CAR_NOT_FOUND,
								t,
							) ?? null,
						[ColumnId.SMSAwaitingPassengersStatus]:
							smsStatusCellProcessing(
								item.smsMessages,
								MessageTemplateActions.OUTPUT_PASSENGERS,
								t,
							) ?? null,
						[ColumnId.SMSWithPassengersStatus]:
							smsStatusCellProcessing(
								item.smsMessages,
								MessageTemplateActions.WITH_PASSENGERS,
								t,
							) ?? null,
						[ColumnId.SMSOrderCompletedStatus]:
							smsStatusCellProcessing(
								item.smsMessages,
								MessageTemplateActions.ORDER_SUCCESSFULLY_COMPLETED,
								t,
							) ?? null,
						[ColumnId.SMSExecutorSwitchedStatus]:
							smsStatusCellProcessing(
								item.smsMessages,
								MessageTemplateActions.DRIVER_SWITCHED,
								t,
							) ?? null,
						[ColumnId.TransportationType]:
							transportationTypeCellProcessing(
								item.additionalFields,
								t,
							) ?? null,
						[ColumnId.Status]:
							statusCellProcessing(item.status, t) ?? null,
						[ColumnId.ReceiptStatus]:
							receiptStatusCellProcessing(item.receipt, t) ??
							null,
						[ColumnId.Source]:
							sourceCellProcessing(item.source, t) ?? null,

						// TODO DP --- Dynamic Cells ( dateFns ) ---
						// [ColumnId.CreateOrderDate]: undefined,
						// [ColumnId.CreateOrderTime]: undefined,
						// [ColumnId.OrderDate]: undefined,
						// [ColumnId.OrderTime]: undefined,
						// [ColumnId.ExecutorArrivalDate]: undefined,
						// [ColumnId.ExecutorArrivalTime]: undefined,
						// [ColumnId.TimeToDelivery]: undefined,
						// [ColumnId.ExecutingStageWithClientsTime]: undefined,
						// [ColumnId.ExecutingStageAcceptedTime]: undefined,
						// [ColumnId.ExecutingStageArrivedTime]: undefined,
						// [ColumnId.ExecutingStageWaitingCustomerTime]: undefined,
						// [ColumnId.IdleTime]: undefined,
				  };

			const model = {
				...item,

				id: item?.id,
				paymentType: item?.paymentType || "card",
				v: item?.v,
				index: item?.index,
				type: item?.type,
				status: item?.status,
				source: item?.source,
				orderNumber: item?.orderNumber,

				cost: item?.cost,

				taxiService: item?.taxiService,

				rate: { id: item?.rate?.id },
				isPreliminary: item?.isPreliminary,
				executorToOrder: item?.executorToOrder,
				executingStages: item?.executingStages,
				executingStage: item?.executingStage,
				executingStageUpdatedAt: item?.executingStageUpdatedAt,
				orderNote: item?.orderNote,
				closedOrderComments: item?.closedOrderComments,
				orderToCarClasses: item?.orderToCarClasses,
				orderToServices: item?.orderToServices,
				phones: item?.phones,
				offer: item?.offer,

				route: item?.route && decompressRoute(item.route),
				sectors: item?.sectors,
				points: getOrderPassengerPoints(item),
				passengers: item?.passengers,
				position: item?.position,

				additionalFields: item?.additionalFields,

				orderDate: item?.orderDate,

				createdAt: item?.createdAt,
				updatedAt: item?.updatedAt,
				closedAt: item?.closedAt,
				smsMessages: item?.smsMessages,
				paymentStatus: item?.paymentStatus || null,
				receipt: item?.receipt ?? null,

				cellsForTable,
				cellsForTableSettings,
			};

			return model;
		} catch (error) {
			logger.error("[Order.fromResponse] Error parsing", {
				item,
				error,
			});
			return undefined;
		}
	}

	static hydrateCellsForTable(model: Order.Model): Order.Model {
		if (model.cellsForTableSettings?.isCellsReady && model.cellsForTable) {
			return model;
		}
		const next = Order.fromResponse(model, { skipCellsForTable: false });
		if (!next) return model;
		return {
			...model,
			cellsForTable: next.cellsForTable,
			cellsForTableSettings: next.cellsForTableSettings,
		};
	}

	static toRequest(model: Order.Model.New): any {
		return {
			v: model.v,
			index: model.index,
			type: model.type,
			status: model.status,
			orderNumber: model.orderNumber,

			taxiService: model.taxiService,

			executorToOrder: model.executorToOrder,

			orderNote: model.orderNote,

			offer: model.offer,
			route: model.route,
			points: model.points,
			passengers: model.passengers,
			position: model.position,

			additionalFields: model.additionalFields,

			orderDate: model.orderDate,
			closedAt: model.closedAt,
		};
	}

	static async store(object: Order.Model.New, options?: Order.StoreOptions) {
		options = defaults(options, Order.defaultSharedOptions);

		try {
			const data: Order.Model = await this.request(
				(prpc) =>
					prpc.theirsModel.orders.create(Order.toRequest(object)),
				{ silent: false, error: true },
			);

			return data;
		} catch (error) {
			logger.error("[Order.update] create", { object, error });
			return null;
		}
	}

	static async update(
		{ id, ...params }: Order.Model.Modified,
		options?: {
			refreshCost?: boolean;
			force?: boolean;
			dispatcherModal?: boolean;
		},
	): Promise<Order.Model | null> {
		try {
			const paramsResolver = this.JSONLike(params);

			logger.info("[Order.update] request ", {
				id,
				params,
				paramsResolver,
			});
			const data: Order.Model = await this.request(
				(prpc) =>
					prpc.theirsModel.orders.update(
						id,
						paramsResolver,
						options || {},
					),
				{ silent: false, error: true },
			);
			logger.info("[Order.update] response ", data);
			return data;
		} catch (error) {
			logger.error("[Order.update] Error", { id, params, error });
			return null;
		}
	}

	static async updateAdditionalFieldsByOrderId(params: {
		orderId: number;
		value: number;
		type:
			| "suburbanDistanceOverride"
			| "idleTimeMilliseconds"
			| "waitingTimeMilliseconds"
			| "hourlyMilliseconds"
			| "additionalCost"
			| "processedByTaximeter";
		/** only for suburbanDistanceOverride */
		shrink?: boolean;
	}): Promise<Order.Model | null> {
		try {
			if (!params?.orderId) return null;
			const res = await this.request(
				(prpc) =>
					prpc.theirsModel.orders.updateAdditionalFieldsByOrderId(
						params,
					),
				{
					silent: false,
					error: true,
				},
			);

			logger.info("[Orders] updateAdditionalFieldsByOrderId", {
				params,
				res,
			});

			return res;
		} catch (error) {
			logger.error("[Order] error updateAdditionalFieldsByOrderId", {
				params,
				error,
			});
			return null;
		}
	}

	static async getById(
		id?: number,
		params?: any,
	): Promise<Order.Model | null> {
		if (!id) return null;
		try {
			const res: Order.Model = await this.request(
				(prpc) => prpc.theirsModel.orders.getById(id, params),

				{
					silent: false,
					error: true,
				},
			);

			const _res: Order.Model | null = Order.fromResponse(res) ?? null;

			logger.info("[Order.getById] request ", {
				id,
				params,
				_res,
			});

			return _res;
		} catch (error) {
			logger.error("[Order] error getById", { id, params, error });
			return null;
		}
	}

	static async getOrderRouteById(
		id?: number,
	): Promise<Order.Model["route"] | null> {
		const prpc = getPRPC();

		if (!prpc) return null;
		if (!id) return null;

		const res: Order.Model["route"] = await createRPCQuery(() =>
			prpc.theirsModel.orders.getOrderRouteById(id),
		);

		logger.info("[Order.getOrderRouteById] request ", {
			id,
			res,
		});

		return res;
	}

	static async getExecutorRoute({
		orderId,
		executorId,
	}: {
		executorId?: number;

		orderId?: number;
	}): Promise<ResGetGPSHistory["data"]> {
		try {
			const data = await this.request(
				(prpc) =>
					prpc.theirsModel.executorLocations.history({
						filters: {
							executorIds: [executorId],
							orderIds: [orderId],
						},
					}),
				{ silent: false, error: true },
			);
			logger.info("[Order.getExecutorRoute]", {
				orderId,
				executorId,
				data,
			});
			return data;
		} catch (error) {
			logger.error("[Order.getExecutorRoute]", { error });
			return [];
		}
	}

	static async getTabCount(
		options: Order.SubscribeOptions,
	): Promise<number | null> {
		try {
			const prpc = getPRPC();
			if (!prpc?.theirsModel?.orders?.getByTab || !options.tab) {
				return null;
			}

			const res = await createRPCQuery(() =>
				prpc.theirsModel.orders.getByTab(options.tab, {
					...options,
					limit: 1,
					offset: 0,
				}),
			);

			const count = res?.pagination?.count;
			return typeof count === "number" ? count : null;
		} catch (error) {
			logger.error("[Order.getTabCount] Error", {
				tab: options.tab,
				error,
			});
			return null;
		}
	}

	static async getByTab(
		tab: Order.OrderTab = "overall",
		params: Order.SubscribeOptions = {},
	): Promise<Order.ResponseGetByTab | null> {
		try {
			const prpc = getPRPC();
			if (!prpc) return null;

			const res: Order.ResponseGetByTab = await createRPCQuery(() =>
				prpc.theirsModel.orders.getByTab(tab, params),
			);

			const _res: Order.ResponseGetByTab | null = res?.items
				? {
						...res,
						items:
							res.items
								.map((item) => Order.fromResponse(item))
								.filter(
									(m): m is Order.Model => m !== undefined,
								) ?? [],
				  }
				: null;

			logger.info("[Order.getByTab] request", {
				tab,
				params,
				res,
				_res,
			});

			// const { callsData } = store.getState().softphoneWidget;

			// res?.items || []

			// res.items

			return _res;
		} catch (error) {
			logger.error("[Order.getByTab] Error", { tab, params, error });
			return null;
		}
	}

	static async copy(id: number, options: Order.CopyOptions) {
		const prpc = getPRPC();

		if (!prpc) return;

		await createRPCQuery(() =>
			prpc.theirsModel.orders.copy(id, {
				copies: options.amount,
				options: {
					points:
						// eslint-disable-next-line no-nested-ternary
						options.type === "all-points"
							? -1
							: options.type === "without-points"
							? 0
							: options.pointsAmount,
				},
			}),
		);
	}

	static async close(id: number, options: Order.CloseOptions) {
		const prpc = getPRPC();

		if (!prpc) return null;
		try {
			logger.info("[Order] close req", { id, options });
			const res = await this.request(
				(prpc) => prpc.theirsModel.orders.close(id, options),
				{
					silent: false,
					error: true,
				},
			);

			logger.info("[Order] close res", { id, options, res });

			return res;
		} catch (error) {
			logger.error("[Order] error close", { id, options, error });
			return null;
		}
	}

	static async assign(id: number, options: Order.AssignOptions) {
		try {
			logger.info("[Order] assign req", { id, options });
			const res = await this.request(
				(prpc) => prpc.theirsModel.orders.offer.assign(id, options),
				{
					silent: false,
					error: true,
				},
			);

			logger.info("[Order] assign res", { id, options, res });

			return res;
		} catch (error) {
			logger.error("[Order] error assign", { id, options, error });
			return null;
		}
	}

	static async accept(id: number, options?: Order.AcceptOptions) {
		try {
			const res = await this.request(
				(prpc) => prpc.theirsModel.orders.offer.accept(id, options),
				{
					silent: false,
					error: true,
				},
			);

			return res;
		} catch (error) {
			logger.error("[Order] error accept", { id, options, error });
			return null;
		}
	}

	static async recalculate(id: number, options?: Order.RecalculateOptions) {
		try {
			const res = await this.request(
				(prpc) =>
					prpc.theirsModel.orders.cost.recalculate(id, {
						useActualRates: options?.useActualRates,
					}),
				{
					silent: false,
					error: true,
				},
			);

			return res;
		} catch (error) {
			logger.error("[Order] error recalculate", { id, error, options });
			return null;
		}
	}

	static async refuse(id: number, options?: Order.RefuseOptions) {
		try {
			const res = await this.request(
				(prpc) => prpc.theirsModel.orders.refuse(id, options),
				{
					silent: false,
					error: true,
				},
			);
			return res;
		} catch (error) {
			logger.error("[Order] error refuse", { id, error, options });
			return null;
		}
	}

	static async startBroadcasting(id: number) {
		try {
			const res = await this.request(
				(prpc) => prpc.theirsModel.orders.broadcast.start(id),
				{
					silent: false,
					error: true,
				},
			);
			return res;
		} catch (error) {
			logger.error("[Order] error startBroadcasting", { id, error });
			return null;
		}
	}

	static async sendOrderToExecuting(id: number) {
		try {
			const res = await this.request(
				(prpc) => prpc.theirsModel.orders.moveToProgress({ id }),
				{
					silent: false,
					error: true,
				},
			);
			return res;
		} catch (error) {
			logger.error("[Order] error sendOrderToExecuting", { id, error });
			return null;
		}
	}

	static async stopBroadcasting(id: number) {
		try {
			const res = await this.request(
				(prpc) => prpc.theirsModel.orders.broadcast.stop(id),
				{
					silent: false,
					error: true,
				},
			);
			return res;
		} catch (error) {
			logger.error("[Order] error stopBroadcasting", { id, error });
			return null;
		}
	}

	static async returnFromTransfer(orderId: number) {
		try {
			logger.info("returnFromTransfer", { orderId });
			const res = await this.request(
				(prpc) =>
					prpc.theirsModel.orders.transfer.returnFromTransfer(
						orderId,
					),
				{
					silent: false,
					error: true,
				},
			);

			logger.info("returnFromTransfer res", { orderId, res });

			return res;
		} catch (error) {
			logger.error("[Order] error returnFromTransfer", {
				orderId,
				error,
			});
			return null;
		}
	}

	static async sendToTransfer(
		orderId: number,
		params?: { type: ValueOrderTransferType },
	) {
		try {
			logger.info("sendToTransfer", { orderId, params });

			if (params?.type) {
				const res = await this.request(
					(prpc) =>
						prpc.theirsModel.orders.transfer.sendToTransfer(
							orderId,
							params,
						),
					{
						silent: false,
						error: true,
					},
				);
				logger.info("sendToTransfer res", { orderId, res, params });
				return res;
			}

			const res = await this.request(
				(prpc) =>
					prpc.theirsModel.orders.transfer.sendToTransfer(orderId),
				{
					silent: false,
					error: true,
				},
			);
			logger.info("sendToTransfer res", { orderId, res, params });

			return res;
		} catch (error) {
			logger.error("Error sendToTransfer", { orderId, params, error });
			return null;
		}
	}

	static async updateCallStatus(
		orderId: number,
		options: Order.UpdateCallStatusOptions,
	) {
		try {
			const res = await this.request(
				(prpc) =>
					prpc.theirsModel.orders.updateCallStatus(orderId, options),
				{
					silent: false,
					error: true,
				},
			);
			logger.info("returnFromTransfer res", { orderId, options, res });

			return res;
		} catch (error) {
			logger.error("[Order] error returnFromTransfer", {
				orderId,
				error,
				options,
			});
			return null;
		}
	}

	static async revert(id: number) {
		try {
			const res = await this.request(
				(prpc) => prpc.theirsModel.orders.revert({ id }),
				{
					silent: false,
					error: true,
				},
			);

			logger.info("[Order] revert", { id, res });
			return res;
		} catch (error) {
			logger.error(error);
			return null;
		}
	}

	static async calculate(
		data: OrderCostRequest,
		params: {
			overall?: boolean;
			dispatcherModal?: boolean;
		} = {
			overall: false,
			dispatcherModal: false,
		},
	): Promise<OrderCostResponse | null> {
		try {
			const res = await this.request(
				(prpc) => prpc?.theirsModel.orders.cost.calculate(data, params),
				{
					silent: false,
					error: true,
				},
			);

			logger.info("[Order] calculate", { data, res, params });
			return res;
		} catch (error) {
			logger.error(error);
			return null;
		}
	}

	/**
	 * The fast counterparty balance check before saving an order. Gives
	 * `null` when it failed or took too long: the order is saved as usual.
	 */
	static async checkBalance(params: {
		orderId?: number;
		checkCardId: number;
		counterpartyId: number;
		amount: number;
		orderDate?: Date | string | number;
		isPreliminary?: boolean;
		taxiServiceId?: number;
	}): Promise<OrderCompanyBillMetadata | null> {
		const timeout = new Promise<null>((resolve) => {
			setTimeout(() => resolve(null), CHECK_BALANCE_TIMEOUT_MS);
		});

		try {
			const res = await Promise.race([
				this.request((prpc) =>
					prpc.theirsModel.orders.cost.checkBalance(params),
				),
				timeout,
			]);

			if (!res) logger.error("[Order] checkBalance: no answer", params);
			return res ?? null;
		} catch (error) {
			logger.error(error);
			return null;
		}
	}

	public static getDatByExecutorForTransfer(
		order: Order.Model | null | undefined,
	): Order.GetDatByExecutorForTransferRes | null {
		const existCar = order?.carToOrder?.at(0)?.car;
		const existExecutor = order?.executorToOrder?.at(0)?.executor;

		if (!existExecutor) return null;

		const carNumber = existCar?.additionalFields?.registrationNumber || "";
		const carModel = existCar?.modelToBodyType?.model?.name || "";
		const carBrand =
			existCar?.modelToBodyType?.model?.baseTypeToBrand?.brand?.name ||
			"";
		const carColor = existCar?.color?.name || "";

		const executorPhones =
			existExecutor?.person?.phones?.map?.(
				(phone) => phone?.number || "",
			) || [];
		const executorTaxiServiceName = existExecutor?.taxiService?.settlement;
		const executorCompanyName = existExecutor?.taxiService?.company?.name;
		const executorTaxiServiceId = existExecutor?.taxiService?.id;
		const taxiServiceAccountCode = existExecutor?.taxiService?.accountCode;

		return {
			carNumber,
			carModel,
			carBrand,
			carColor,
			executorPhones,
			executorTaxiServiceId,
			executorTaxiServiceName,
			executorCompanyName,
			taxiServiceAccountCode,
		};
	}

	// static async destroy(
	// 	id: number[] | number,
	// 	options?: Order.DestroyOptions,
	// ) {
	// 	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	// 	options = defaults(options, Order.defaultSharedOptions);

	// 	const prpc = getPRPC();

	// 	if (!prpc) return;

	// 	if (Array.isArray(id))
	// 		await Promise.all(id.map((id) => destroyOne(id)));
	// 	else await destroyOne(id);

	// 	// if (options.deprecate) Order.deprecateAll();
	// }

	public static async subscribe(
		options: Order.SubscribeOptions,
		onUpdate: Subscription.OnUpdate<Order.Model>,
	): Promise<Subscription<Order.SubscribeOptions> | null> {
		let disposed = false;
		let currentOptions = options;

		// `fromResponse` builds ~40 table cells per order, so remapping the whole
		// list on every event batch is what saturates the main thread once the
		// list grows. `ModelEventConstructor` keeps object identity for models an
		// event did not touch, so their previous mapping can be reused.
		let mappedByItem = new WeakMap<object, Order.Model>();
		let mappedForDeps: unknown[] = [];
		let lastRawModels: unknown[] = [];
		/** отмена запланированного флаша буфера событий */
		let cancelEventFlush: (() => void) | null = null;
		const pendingEvents: any[] = [];

		/**
		 * Батчим события под кадр. В скрытой вкладке rAF не тикает, а
		 * ответы getById применяются сразу — чтобы при возврате старый буфер
		 * не лёг поверх них, в скрытой вкладке флашим по таймеру.
		 */
		const scheduleFrame = (callback: () => void): (() => void) => {
			const hidden =
				typeof document !== "undefined" &&
				document.visibilityState === "hidden";
			if (!hidden && typeof requestAnimationFrame === "function") {
				const handle = requestAnimationFrame(callback);
				return () => cancelAnimationFrame(handle);
			}
			const handle = setTimeout(callback, 0);
			return () => clearTimeout(handle);
		};

		const mapModels = (items: unknown[]): Order.Model[] => {
			const { colors, order: orderSettings } = store.getState().settings;
			const { language } = store.getState().session;
			let skipCellsForTable = false;
			const isClosedSubscribe =
				currentOptions.tab === "closed" ||
				currentOptions.tab === "own_closed";
			if (currentOptions.tab !== "all" && !isClosedSubscribe) {
				skipCellsForTable =
					currentOptions.countOnly ||
					(Boolean(currentOptions.tab) &&
						currentOptions.tab !==
							store.getState().ordersPageReducer?.ordersType);
			}
			const deps = [colors, orderSettings, language, skipCellsForTable];

			if (deps.some((dep, index) => dep !== mappedForDeps[index])) {
				mappedByItem = new WeakMap();
				mappedForDeps = deps;
			}

			let hits = 0;
			let misses = 0;
			const started = performance.now();
			const models = compact(
				items.map((item) => {
					if (typeof item !== "object" || item === null) {
						misses += 1;
						return Order.fromResponse(item, { skipCellsForTable });
					}

					// Истечение оффера кэш не сбрасывает: ячейка позывного сама
					// перерисуется по дедлайну (useOfferExpired), а сервер
					// следом пришлёт снапшот с `offer: null` новой ссылкой.
					const cached = mappedByItem.get(item);
					if (cached) {
						hits += 1;
						return cached;
					}

					misses += 1;
					const model = Order.fromResponse(item, {
						skipCellsForTable,
					});
					if (model) mappedByItem.set(item, model);
					return model;
				}),
			);
			recordFromResponse(
				performance.now() - started,
				items.length,
				hits,
				misses,
			);
			return models;
		};

		let lastEmitted: Order.Model[] = [];
		let lastTotal: number | undefined;

		const emitModels = (
			rawModels: unknown[],
			metadata?: { total?: number },
		) => {
			const models = mapModels(rawModels);
			const total = metadata?.total ?? lastTotal ?? models.length;
			if (
				lastEmitted.length === models.length &&
				lastEmitted.every((item, index) => item === models[index]) &&
				lastTotal === total
			) {
				return;
			}
			lastEmitted = models;
			lastTotal = total;
			logger.info("[Orders] subscribe", {
				tab: options.tab,
				count: models.length,
				total,
			});
			onUpdate({
				metadataState: { total },
				models,
			});
		};

		const modelEventConstructor = new ModelEventConstructor({
			hydrateWindowSize: options.countOnly ? 0 : options.limit,
			onUpdate: (state) => {
				if (disposed) return;

				lastRawModels = compact(state.models);
				emitModels(
					lastRawModels,
					state.metadataState as { total?: number },
				);
				staleWatchdog.arm();
			},
		});

		// По currentOptions, а не options: update(opt) может сменить таб.
		const isClosedTab = () =>
			currentOptions.tab === "closed" ||
			currentOptions.tab === "own_closed";

		const findRaw = (id: number) =>
			lastRawModels.find((raw) => (raw as { id?: number })?.id === id);

		// Точечные getById: очередь, лимит и правила применения ответа —
		// см. ordersHydrate. Сервис только подключает PRPC и конструктор.
		const hydrate = createHydrateCoordinator({
			fetch: (id) => {
				recordHydrate();
				return Promise.resolve(
					this.request(
						(prpc) => prpc.theirsModel.orders.getById(id),
						{ silent: false, error: true },
					),
				);
			},
			// Нет соединения — Base.request вернёт null, который нельзя
			// отличить от «заказа нет». Пропускаем, watchdog перепроверит.
			// countOnly-подписке строки не нужны — не ходить за ними.
			canFetch: () => Boolean(getPRPC()) && !currentOptions.countOnly,
			isClosedTab,
			has: (id) => modelEventConstructor.has(id),
			isHydrating: () => modelEventConstructor.isHydrating(),
			findRaw,
			apply: (event) => modelEventConstructor.onEvent([event]),
			onFetched: (raw) => {
				primeOfferDeadline(raw);
				// Сначала применить накопленные WS-события, потом судить
				// ответ: иначе `before`/`has` увидят состояние до буфера, а
				// буфер потом перепишет свежий ответ.
				// eslint-disable-next-line @typescript-eslint/no-use-before-define
				flushPendingEvents();
			},
		});

		// Страховка от потерянного серверного события: см. ordersStaleWatchdog.
		const staleWatchdog = createStaleWatchdog({
			getModels: () => lastRawModels,
			isActive: () =>
				!disposed && !isClosedTab() && !currentOptions.countOnly,
			enqueueHydrate: hydrate.enqueue,
		});

		const applyEventBatch = (events: any[] | undefined) => {
			if (disposed) return;
			logger.info("[Orders] subscribe applyEventBatch", events);
			recordWsEvents(events?.length ?? 0);
			const split = splitOrderEvents(events, isClosedTab());
			hydrate.noteBatch(split);
			if (split.windowReset) {
				// Окно пересобирается: конструктор не эмитит до прихода
				// ADD-чанков, и старый список не должен ни взводить watchdog,
				// ни служить `before` для ответов getById.
				lastRawModels = [];
				staleWatchdog.arm();
			}
			// сначала применить батч, потом ставить hydrate: `before` должен
			// быть снапшотом после батча, иначе свежий ответ сочтём устаревшим
			if (split.immediate.length) {
				modelEventConstructor.onEvent(split.immediate);
			}
			split.hydrateIds.forEach(hydrate.enqueue);
		};

		const flushPendingEvents = () => {
			// принудительный флаш (перед ответом getById) снимает плановый
			cancelEventFlush?.();
			cancelEventFlush = null;
			if (disposed) return;
			const batch = pendingEvents.splice(0);
			if (batch.length) applyEventBatch(batch);
		};

		const subscription = await SubscriptionPool.add(
			(prpc) =>
				prpc.theirsModel.orders.subscribe({
					// currentOptions: SubscriptionPool.onReconnect зовёт этот же
					// callback, и сервер должен получить актуальные фильтры
					params: this.optionsToRequest(currentOptions),
					ping: () => true,
					onEvent: (events) => {
						if (disposed) return;
						logger.info("[Orders] subscribe events", events);
						// Дедлайн оффера фиксируем в момент получения: в фоновой
						// вкладке rAF-флаш ждёт возврата, и считать его позже
						// значит сдвинуть на время простоя.
						for (const event of events ?? []) {
							primeOfferDeadline(event?.data);
						}
						pendingEvents.push(...(events ?? []));
						if (cancelEventFlush == null) {
							cancelEventFlush =
								scheduleFrame(flushPendingEvents);
						}
					},
					onError: (error) => {
						logger.error(error);
					},
				}),
			{ name: "Order.subscribe" },
		);

		return {
			unsubscribe: () => {
				disposed = true;
				staleWatchdog.dispose();
				if (cancelEventFlush != null) {
					cancelEventFlush();
					cancelEventFlush = null;
				}
				pendingEvents.length = 0;
				hydrate.dispose();
				return subscription.unsubscribe();
			},
			update: (opt: Order.SubscribeOptions) => {
				currentOptions = opt;
				modelEventConstructor.setHydrateWindowSize(
					opt.countOnly ? 0 : opt.limit,
				);
				staleWatchdog.arm();
				return subscription?.update(this.optionsToRequest(opt));
			},
		} as Subscription<Order.SubscribeOptions>;
	}

	private static optionsToRequest(options: Order.SubscribeOptions) {
		const request: Record<string, unknown> = {
			subscriptionVersion: "1",
			query: options.query || undefined,

			tab: options.tab,
			customerIds: options.customerIds,
			executorIds: options.executorIds,
			taxiServiceIds: options.taxiServiceIds,
			counterpartyIds: options.counterpartyIds,
			checkIds: options.checkIds,
			checkCardIds: options.checkCardIds,
			employeeIds: options.employeeIds,
			hasCounterparty: options.hasCounterparty,
			hasEmployee: options.hasEmployee,
			dateRange: options.dateRange,
			agentIds: options.agentIds,
			dispatcherIds: options.dispatcherIds,

			hasExecutor: options.hasExecutor,

			customerPhones: options.customerPhones,
			executorCallSigns: options.executorCallSigns,
			carCallSigns: options.carCallSigns,
			carRegistrationNumbers: options.carRegistrationNumbers,
			pickupAddress: options.pickupAddress,
			destinationAddress: options.destinationAddress,
			lang: options?.lang,
			withoutRoute: options?.withoutRoute,
		};

		if (options.tab === "closed") {
			if (typeof options.offset === "number") {
				request.offset = options.offset;
			}
			if (typeof options.limit === "number") {
				request.limit = options.limit;
			}
			if (options.order) {
				request.order = options.order;
			}
		}

		return request;
	}

	static Global = {
		async index(options: Order.SubscribeOptions) {
			const prpc = getPRPC();

			if (!prpc) return null;
			if (!prpc.theirsModel?.orders?.getAll) return null;

			const result = await createRPCQuery(() =>
				prpc.theirsModel.orders.getAll({
					offset: options.offset,
					limit: options.limit,
					// order: options.order,
					query: options.query || undefined,

					tab: options.tab,
					customerIds: options.customerIds,
					taxiServiceIds: options.taxiServiceIds,
					// lang: options.language,
				}),
			);

			return {
				cache: result.items.map((item) => Order.fromResponse(item)),
				offset: result.pagination.offset,
				limit: result.pagination.count,
				total: result.pagination.count,
				deprecated: false,
			};
		},
	};

	public static exportExcel = async (
		_data: Order.Model[],
		options: {
			dateFrom: CalendarNamespace.Value;
			dateTo: CalendarNamespace.Value;
			headerTitle: string;
			tableColumn: string[];
			columnStyles: UserOptions["columnStyles"];
			ColumnId: Record<string, string>;
			columnIds: string[];
			translationsColumnIds: string[];
			lang: ValueLanguage;
			t: TFunction;
			dateFns: DateFns;
			timezoneName: string;
			orderSettings: OrderSettingNameSpace.OrderSettings;
			currentTime: Date;
			ordersStatistics: string[][];
		},
	) => {
		if (!_data?.length) return;

		const {
			dateFrom,
			dateTo,
			headerTitle,
			tableColumn = [],
			columnStyles,
			ColumnId,
			columnIds,
			translationsColumnIds,
			lang,
			t,
			dateFns,
			timezoneName,
			orderSettings,
			currentTime,
			ordersStatistics,
		} = options;

		const namefile = generateFileNameFileHelper({
			title: headerTitle,
			dateFrom,
			dateTo,
		});

		const workbook = new ExcelJS.Workbook();

		const createReport = async (items: Order.Model[]) => {
			const worksheet = workbook.addWorksheet(namefile);

			columnIds.forEach((colIndex, index) => {
				const cellWidth: number = +(
					columnStyles?.[colIndex]?.cellWidth ?? 80
				);

				if (typeof cellWidth === "number" && cellWidth > 0) {
					worksheet.getColumn(index + 1).width =
						Math.round(cellWidth);
				} else {
					logger.warn(
						`2 Width for column ${colIndex} is undefined or invalid: cellWidth`,
						cellWidth,
					);
				}
			});

			const titleRow = worksheet.addRow(
				columnIds.map(
					(textEN, index) =>
						(textEN = translationsColumnIds?.[index] ?? textEN),
				),
			);
			titleRow.font = {
				name: "Calibri",
				size: 11,
			};
			titleRow.alignment = {
				horizontal: "center",
				vertical: "middle",
				wrapText: true,
			};

			const maxHeight = Math.min(
				3,
				Math.max(
					...tableColumn.map((cell) => {
						if (typeof cell === "string") {
							return Math.ceil(cell.length / 10);
						}
						return 1;
					}),
				),
			);

			titleRow.height = 30;

			items.forEach((item) => {
				const row: (string | number | undefined | Date | null)[] = [];

				columnIds.forEach((columnId) => {
					let value: Date | string | number | null = null;

					switch (columnId) {
						case ColumnId.AdditionalPhone:
							value =
								additionalPhoneCellProcessing(item.phones) ??
								null;
							break;
						case ColumnId.CarClass:
							value =
								carClassCellProcessing(
									item.orderToCarClasses,
									lang,
								) ?? null;
							break;

						case ColumnId.CloseReason:
							value = closeReasonCellProcessing(item, t) ?? null;
							break;

						case ColumnId.ClientRefusalReason:
							value =
								clientRefusalReasonCellProcessing(
									item,
									lang,
									t,
								) ?? null;
							break;

						case ColumnId.ClosedTime:
							value =
								closedTimeCellProcessing(item, dateFns) ?? null;
							break;

						case ColumnId.Company:
							value =
								companyCellProcessing(item.taxiService, lang) ??
								null;
							break;

						case ColumnId.Counterparty:
							value =
								counterpartyCellProcessing(item.counterparty) ??
								null;
							break;

						case ColumnId.CounterpartyCheck:
							value =
								counterpartyCheckCellProcessing(
									item.checkCard,
								) ?? null;
							break;

						case ColumnId.CounterpartyCheckCard:
							value =
								counterpartyCheckCardCellProcessing(
									item.checkCard,
								) ?? null;
							break;

						case ColumnId.CreateOrderDate:
							value =
								createOrderDateCellProcessing(
									item.createdAt,
									dateFns,
								) ?? null;
							break;

						case ColumnId.CreateOrderTime:
							value =
								createOrderTimeCellProcessing(
									item.createdAt,
									dateFns,
								) ?? null;
							break;

						case ColumnId.CustomerCallStatus:
							value =
								customerCallStatusCellProcessing(item)
									?.content ?? null;
							break;

						case ColumnId.CustomerFullName:
							value =
								customerFullNameCellProcessing(item) ?? null;
							break;

						case ColumnId.CustomerNote:
							value = customerNoteCellProcessing(item) ?? null;
							break;

						case ColumnId.DestinationAddress:
							value =
								destinationAddressCellProcessing(item, t) ??
								null;
							break;

						case ColumnId.DestinationSector:
							value =
								destinationSectorCellProcessing(item, lang) ??
								null;
							break;

						case ColumnId.DestinationSettlement:
							value =
								destinationSettlementCellProcessing(item) ??
								null;
							break;

						case ColumnId.Discount:
							value = discountCellProcessing(item, lang) ?? null;
							break;

						case ColumnId.DispatcherCallSign:
							value =
								dispatcherCallSignCellProcessing(
									item.closedOrderComments,
									t,
								) ?? null;
							break;

						case ColumnId.ExecutingStage:
							value =
								executingStageCellProcessing(
									item.executingStage,
									t,
								) ?? null;
							break;

						case ColumnId.ExecutingStageAcceptedTime:
							value =
								executingStageAcceptedTimeCellProcessing(
									item.executingStages,
									dateFns,
								)?.content ?? null;
							break;

						case ColumnId.ExecutingStageArrivedTime:
							value =
								executingStageArrivedTimeCellProcessing(
									item.executingStages,
									dateFns,
								)?.content ?? null;
							break;

						case ColumnId.ExecutingStageWaitingCustomerTime:
							value =
								executingStageWaitingCustomerTimeCellProcessing(
									item,
									dateFns,
								) ?? null;
							break;

						case ColumnId.ExecutingStageWithClientsTime:
							value =
								executingStageWithClientsTimeCellProcessing(
									item,
									dateFns,
								) ?? null;
							break;

						case ColumnId.ExecutorArrivalDate:
							value =
								executorArrivalDateCellProcessing(
									item,
									dateFns,
								) ?? null;
							break;

						case ColumnId.ExecutorArrivalTime:
							value =
								executorArrivalTimeCellProcessing(
									item,
									dateFns,
								) ?? null;
							break;

						case ColumnId.ExecutorCallSign:
							value =
								executorCallSignCellProcessing(item)?.content ??
								null;
							break;

						case ColumnId.ExecutorCallStatus:
							value =
								executorCallStatusCellProcessing(item)
									?.content ?? null;
							break;

						case ColumnId.ExecutorLate:
							value =
								executorLateCellProcessing(
									item.executingStages,
								) ?? null;
							break;

						case ColumnId.ExecutorNote:
							value = executorNoteCellProcessing(item) ?? null;
							break;

						case ColumnId.IdleTime:
							value =
								idleTimeCellProcessing(item, dateFns) ?? null;
							break;

						case ColumnId.OrderDate:
							value =
								orderDateCellProcessing(item, dateFns)
									?.content ?? null;
							break;

						case ColumnId.OrderNumber:
							value =
								orderNumberCellProcessing(item.orderNumber) ??
								null;
							break;

						case ColumnId.OrderPrice:
							value =
								orderPriceCellProcessing(
									item,
									undefined,
									getCurrencyFromGlobal(),
								)?.content ?? null;
							break;

						case ColumnId.OrderTime:
							value =
								orderTimeCellProcessing(
									item,
									dateFns,
									timezoneName,
								)?.content ?? null;
							break;

						case ColumnId.ParkLine:
							value =
								parkLineCellProcessing(item.park_line) ?? null;
							break;

						case ColumnId.Parameters:
							value =
								parametersCellProcessing(
									item.additionalFields,
									t,
								) ?? null;
							break;

						case ColumnId.PaymentType:
							value =
								paymentTypeCellProcessing(item, t)?.content ??
								null;
							break;

						case ColumnId.PaymentStatus:
							value =
								paymentStatusCellProcessing(item, t)?.content ??
								null;
							break;

						case ColumnId.Phone:
							value =
								phoneCellProcessing(item, orderSettings)
									?.content ?? null;
							break;

						case ColumnId.PickupAddress:
							value =
								pickupAddressCellProcessing(item, t)?.content ??
								null;
							break;

						case ColumnId.PickupSector:
							value =
								pickupSectorCellProcessing(item, lang) ?? null;
							break;

						case ColumnId.PickupSettlement:
							value =
								pickupSettlementCellProcessing(item) ?? null;
							break;

						case ColumnId.RideNumber:
							value =
								rideNumberCellProcessing(item.passengers) ??
								null;
							break;

						case ColumnId.Services:
							value =
								servicesCellProcessing(
									item.orderToServices,
									lang,
								) ?? null;
							break;

						case ColumnId.SMSAwaitingPassengersStatus:
							value =
								smsStatusCellProcessing(
									item.smsMessages,
									MessageTemplateActions.OUTPUT_PASSENGERS,
									t,
								)?.content ?? null;
							break;

						case ColumnId.SMSCarNotFoundStatus:
							value =
								smsStatusCellProcessing(
									item.smsMessages,
									MessageTemplateActions.CAR_NOT_FOUND,
									t,
								)?.content ?? null;
							break;

						case ColumnId.SMSExecutorSwitchedStatus:
							value =
								smsStatusCellProcessing(
									item.smsMessages,
									MessageTemplateActions.DRIVER_SWITCHED,
									t,
								)?.content ?? null;
							break;

						case ColumnId.SMSLateStatus:
							value =
								smsStatusCellProcessing(
									item.smsMessages,
									MessageTemplateActions.LATE,
									t,
								)?.content ?? null;
							break;

						case ColumnId.SMSOrderCompletedStatus:
							value =
								smsStatusCellProcessing(
									item.smsMessages,
									MessageTemplateActions.ORDER_SUCCESSFULLY_COMPLETED,
									t,
								)?.content ?? null;
							break;

						case ColumnId.SMSWillBeAtStatus:
							value =
								smsStatusCellProcessing(
									item.smsMessages,
									MessageTemplateActions.WILL_BE_TIME,
									t,
								)?.content ?? null;
							break;

						case ColumnId.SMSWithPassengersStatus:
							value =
								smsStatusCellProcessing(
									item.smsMessages,
									MessageTemplateActions.WITH_PASSENGERS,
									t,
								)?.content ?? null;
							break;

						case ColumnId.Status:
							value =
								statusCellProcessing(item.status, t) ?? null;
							break;

						case ColumnId.ReceiptStatus:
							value =
								receiptStatusCellProcessing(item.receipt, t)
									?.content ?? null;
							break;

						case ColumnId.Source:
							value =
								sourceCellProcessing(item.source, t) ?? null;
							break;

						case ColumnId.SourceCallSing:
							value =
								sourceCallSignCellProcessing(item, t)
									?.content ?? null;
							break;

						case ColumnId.Tariff:
							value =
								tariffCellProcessing(item.rate, lang) ?? null;
							break;

						case ColumnId.TaxiService:
							value =
								taxiServiceCellProcessing(
									item.taxiService,
									lang,
								) ?? null;
							break;

						// case ColumnId.TimeToDelivery:
						// 	value =
						// 		timeToDeliveryCellProcessing(
						// 			item,
						// 			dateFns,
						// 			currentTime,
						// 		)?.content ?? null;
						// 	break;
						// ? TimeToDelivery don't use in archive

						case ColumnId.TotalRideCount:
							value =
								totalRideCountCellProcessing(item.passengers) ??
								null;
							break;

						case ColumnId.TransferFromTaxiService:
							value =
								transferFromTaxiServiceCellProcessing(
									item,
									lang,
								)?.content ?? null;
							break;

						case ColumnId.TransferToTaxiService:
							value =
								transferToTaxiServiceCellProcessing(item, lang)
									?.content ?? null;
							break;

						case ColumnId.TransportationType:
							value =
								transportationTypeCellProcessing(
									item.additionalFields,
									t,
								)?.content ?? null;
							break;

						default:
							value = null;
							break;
					}

					row.push(value);
				});

				const newRow = worksheet.addRow(row);
				newRow.alignment = {
					horizontal: "center",
					vertical: "middle",
					wrapText: true,
				};
				newRow.font = { name: "Arial", size: 10 };

				newRow.eachCell((cell) => {
					// * East number
					if (
						typeof cell.value === "string" &&
						/[.,]\d/.test(cell.value)
					) {
						const raw = cell.value.replace(/\s/g, "");
						const num = parseFloat(raw.replace(",", "."));
						if (!Number.isNaN(num)) {
							cell.value = num;
							cell.numFmt = "0.00";
						}
					}

					// * Cost
					if (typeof cell.value === "string") {
						const trimmed = cell.value.trim();

						if (/^\d/.test(trimmed)) {
							const suffix = CURRENCY_SUFFIXES.find((suf) =>
								trimmed
									.toLowerCase()
									.endsWith(suf.toLowerCase()),
							);

							if (suffix) {
								const valueWithoutCurrency = trimmed
									.slice(0, -suffix.length)
									.trim()
									.replace(",", ".");

								const num = parseFloat(valueWithoutCurrency);

								const currency =
									getCurrencySymbol(suffix) || "₴";

								if (!Number.isNaN(num)) {
									cell.value = num;
									cell.numFmt =
										getExcelCurrencyFormat(currency);
									cell.alignment = { wrapText: true };
								}
							}
						}
					}
				});

				const maxHeight = Math.min(
					3,
					Math.max(
						...row.map((cell) => {
							if (typeof cell === "string") {
								return Math.ceil(cell.length / 10);
							}
							return 1;
						}),
					),
				);

				newRow.height = maxHeight * 13;

				newRow.alignment = {
					horizontal: "center",
					vertical: "middle",
					wrapText: true,
				};
			});

			worksheet.addRow([]);
			worksheet.addRow([]);

			const startRowIndex = worksheet.lastRow?.number
				? worksheet.lastRow.number + 1
				: 1;

			const maxLength = Math.max(
				...ordersStatistics.map((group) => group.length),
			);

			for (let rowIndex = 0; rowIndex < maxLength; rowIndex++) {
				const rowValues: (string | null)[] = [];
				const mergeInstructions: { start: number; end: number }[] = [];

				let colIndex = 1;

				ordersStatistics.forEach((group) => {
					const text = group[rowIndex] ?? "";

					const match = text.match(/^(.*?)(\d[\d\s()грн]*)\s*$/);
					const part1 = match?.[1]?.trim() ?? text;
					const part2 = match?.[2]?.trim() ?? "";

					rowValues[colIndex - 1] = part1;
					rowValues[colIndex] = null;
					rowValues[colIndex + 1] = part2;

					mergeInstructions.push({
						start: colIndex,
						end: colIndex + 1,
					});

					colIndex += 3;
				});

				const row = worksheet.addRow(rowValues);

				mergeInstructions.forEach(({ start, end }) => {
					worksheet.mergeCells(row.number, start, row.number, end);
				});

				row.font = { name: "Arial", size: 9 };
				row.alignment = {
					vertical: "middle",
					wrapText: true,
				};

				for (let i = 1; i <= row.cellCount; i += 3) {
					row.getCell(i).alignment = { horizontal: "left" };
					row.getCell(i + 2).alignment = { horizontal: "center" };
				}
			}

			const endRowIndex = startRowIndex + maxLength - 1;
			const endColumnIndex = ordersStatistics.length * 3;

			for (let row = startRowIndex; row <= endRowIndex; row++) {
				for (let col = 1; col <= endColumnIndex; col++) {
					const cell = worksheet.getCell(row, col);

					const isTop = row === startRowIndex;
					const isBottom = row === endRowIndex;
					const isLeft = col === 1;
					const isRight = col === endColumnIndex;

					cell.border = {
						top: isTop ? { style: "thin" } : undefined,
						bottom: isBottom ? { style: "thin" } : undefined,
						left: isLeft ? { style: "thin" } : undefined,
						right: isRight ? { style: "thin" } : undefined,
					};
				}
			}

			const buffer = await workbook.xlsx.writeBuffer();

			const blob = new Blob([buffer], {
				type: "application/octet-stream",
			});
			saveAs(blob, nameFileExcelOnly);
		};

		const nameFileExcelOnly = `${namefile}.xlsx`;

		createReport(_data);
	};
}
export enum CustomerBonusUsageType {
	BonusTrip = "bonusTrip",
	BonusBalance = "bonusBalance",
}

export enum OrderTransferTypeEnum {
	LOCAL = "local",
	GLOBAL = "global",
	OUTSIDE = "outside",
}

export const OrderTransferType = {
	LOCAL: "local",
	GLOBAL: "global",
	OUTSIDE: "outside",
} as const;
export type TypeOrderTransferType = typeof OrderTransferType;
export type ValueOrderTransferType =
	(typeof OrderTransferType)[keyof typeof OrderTransferType];

export enum OrderTransferSendProcessModeEnum {
	AUTO = "auto",
	MANUAL = "manual",
}
export const OrderTransferSendProcessMode = {
	AUTO: "auto",
	MANUAL: "manual",
} as const;
export type TypeOrderTransferSendProcessMode =
	typeof OrderTransferSendProcessMode;
export type ValueOrderTransferSendProcessMode =
	(typeof OrderTransferSendProcessMode)[keyof typeof OrderTransferSendProcessMode];

export interface CustomerBonusUsage {
	/**
	 * Indicates whether the customer uses bonuses or not.
	 */
	active: boolean;

	/**
	 * Type of the bonus usage.
	 */
	type: CustomerBonusUsageType;

	/**
	 * The limits of the bonus usage.
	 */
	limit: {
		active: boolean;
		maxAmount: number;
	};
}

export interface CustomerDiscountUsage {
	/**
	 * Indicates whether the customer uses discounts or not.
	 */
	active: boolean;
}

export interface Discount {
	active: boolean;
	bonusUsage: CustomerBonusUsage;
	discountUsage: CustomerDiscountUsage;
}

namespace Order {
	export interface OrderTransfer {
		/**
		 * Whether the order is found by distribution and initial tasks was applied to it or not.
		 */
		initialDistributeStage?: boolean;

		lastReceivedOrder?: Order.Model | null;

		executor?: {
			carNumber?: string;
			carModel?: string;
			carBrand?: string;
			carColor?: Record<Language, string>;
			executorPhones?: string[];
			executorTaxiServiceName?: Record<Language, string>;
			executorCompanyName?: Record<Language, string>;
			executorTaxiServiceId?: number;
			taxiServiceAccountCode?: string;
		} | null;

		/**
		 * sendProcess.mode !== null - заказ находится в процессе перекидки
		 * sendProcess.mode === null - заказ не находится в процессе перекидки
		 */
		sendProcess?: {
			/**
			 * AUTO - если заказ прошел круги в распределении и вышел с FREE_WAVE
			 * MANUAL - если заказ был отправлен вручную (sendToTransfer с id)
			 */
			mode: ValueOrderTransferSendProcessMode | null;
			/**
			 * AUTO - если заказ проходит органическое переключение стадий (по умолчанию)
			 * MANUAL - если заказ был отправлен вручную (sendToTransfer с id и type)
			 */
			rotationMode: ValueOrderTransferSendProcessMode | null;
			/*
			 * Текущая стадия перекидки заказа
			 */
			currentTransferStage: ValueOrderTransferType | null;

			lastModeSwitchTimeStamp: number;
		};
	}

	export interface IAdditionalFields {
		hasAgent?: boolean;
		/**
		 * The usage of the customer bonuses.
		 *
		 * If the customer want to use bonuses, then the `bonusUsage` field should be set.
		 * Contains the bonus usage settings like limits, type, amount, etc.
		 */
		discount?: Discount | null;

		/** @deprecated not used  */
		compensation?: {
			active: boolean;
			type: "percent" | "uah";
			whom: "customer" | "taxiService";
			value: number;
		};
		/** @deprecated not used  */
		surcharge?: {
			active: boolean;
			type: "percent" | "uah";
			value: number;
		};

		/** @deprecated not used  */
		rideBonus?: {
			active: boolean;
			number: number;
			value: number;
		};
		/** @deprecated not used  */
		phoneTopUp?: {
			active: boolean;
			value: number;
		};

		idleTimeMilliseconds: number;
		waitingTimeMilliseconds: number;

		displaySettings?: {
			color?: string | number;
			showCustomerPhone?: boolean;
		};
		transportationType: "passenger" | "cargo";
		additionalCost: number;
		arbitraryCost?: number;
		hourlyMilliseconds: number;
		suburbanDistanceOverride?: {
			value: number;
			shrink?: boolean;
		};
		customerNotes?: string;
		executorNotes?: string;
		passengersCount?: number;
		rateSettings?: {
			includePickupCost?: boolean;
			isRoundTrip?: boolean;
			enableHourlyService?: boolean;
			includePickupMargin?: boolean;
		};

		taximeter: boolean;
		processedByTaximeter: boolean;

		transfer?: Order.OrderTransfer;

		initiator?: {
			id: number;
			callSign: string;
		};

		/**
		 * Оплата наличного заказа картой по ссылке: QR водителя или SMS,
		 * которую отправил диспетчер. Пишет только сервер.
		 */
		qrPayment?: QrPayment | null;
	}

	export interface QrPayment {
		url: string;
		invoiceId: string;
		amount: number;
		provider: string;
		status: "pending" | "paid" | "failed" | "cancelled";
		createdAt: string;
		paidAt?: string | null;
		paidAmount?: number | null;
		lastFailureReason?: string | null;
		lastFailedAt?: string | null;
		closeOnPayment?: boolean;
		/** Кто выпустил ссылку; без поля — водитель. */
		source?: "executor" | "dispatcher";
		dispatcherId?: number | null;
		/** Отправки ссылки по SMS: кому и когда. */
		smsSends?: {
			phone: string;
			sentAt: string;
			dispatcherId?: number | null;
		}[];
		cancelledBy?: "executor" | "dispatcher" | "system" | null;
		cancelledAt?: string | null;
	}

	export type OrderSMSMessageStatus =
		| "sent"
		| "progress"
		| "success"
		| "failure";

	export interface IOrderSMSMessage {
		action: MessageTemplateActions;
		status: OrderSMSMessageStatus;
		text: string;
		timestamp: number;
	}

	export interface Phone {
		id?: number;
		number: string;
		group: number;
	}

	export enum Source {
		Phone = "phone",
		App = "app",
		Website = "website",
		Executor = "executor",
		Dispatcher = "dispatcher",
	}

	export enum PaymentType {
		Card = "card",
		Cash = "cash",
		Invoice = "invoice",
		CompanyBill = "company_bill",
	}

	export type RawOrder = Order;

	export enum OrderCostCalculationStage {
		ARBITRARY_COST = "arbitrary_cost",
		PICKUP_NEAREST_COST = "pickup_nearest_cost",
		PICKUP_POINT_COST = "pickup_point_cost",
		PICKUP_ZONE_COST = "pickup_zone_cost",
		PICKUP_ZONE_REVERSE_COST = "pickup_zone_reverse_cost",
		PICKUP_SETTLEMENT_COST = "pickup_settlement_cost",
		BOARDING_COST = "boarding_cost",
		ADDITIONAL_COST = "additional_cost",
		FIXED_RATE = "fixed_rate",
		RATE_GRID_SUBURBAN_COST = "rate_grid_suburban_cost",
		RATE_GRID_SETTLEMENT_COST = "rate_grid_settlement_cost",
		HOURLY_RATE_WAITING = "hourly_rate_waiting",
		HOURLY_RATE_IDLE = "hourly_rate_idle",
		HOURLY_RATE_RIDE = "hourly_rate_ride",
		MIN_AFFORDABLE_ROUTE_COST = "min_affordable_route_cost",
		SETTLEMENT_ROUTE_COST = "settlement_route_cost",
		SUBURBAN_ROUTE_COST = "suburban_route_cost",
		GENERAL_MARGIN = "margin_general",
		ORDER_SUM_MARGIN = "margin_surcharge_to_order_sum",
		PRELIMINARY_MARGIN = "preliminary_margin",
		APP_ORDER_MARGIN = "online_order_margin",
		EXECUTOR_ORDER_MARGIN = "executor_order_margin",
		WEBSITE_ORDER_MARGIN = "website_order_margin",
		PICKUP_COST_MARGIN = "pickup_cost_margin",
		PASSENGER_MARGIN = "passengers_margin",
		SERVICE_MARGIN = "services_margin",
		ADDITIONAL_POINT_MARGIN = "additional_point_margin",
		CREDIT_CARD_PAYMENT_MARGIN = "credit_card_payment_margin",
		INVOICE_PAYMENT_MARGIN = "invoice_payment_margin",
		NON_CASH_PAYMENT_MARGIN = "non_cash_payment_margin",
	}

	export type BasicCostCalculationStage = {
		value: number;
		stage: OrderCostCalculationStage;
	};

	export type OrderCost = {
		raw: number;
		stages: BasicCostCalculationStage[];
		value: number;
		rounded: string;
		currency: Currency.Model;
		settings: any;
	};

	export interface GetDatByExecutorForTransferRes {
		carNumber?: string;
		carModel?: string;
		carBrand?: string;
		carColor?: Record<Language, string>;
		executorPhones?: string[];
		executorTaxiServiceName?: Record<Language, string>;
		executorCompanyName?: Record<Language, string>;
		executorTaxiServiceId?: number;
		taxiServiceAccountCode?: string;
	}

	export const ORDERS_STAGE = {
		LIVE: "live",
		PRELIMINARY: "preliminary",
		EXECUTABLE: "executable",
	} as const;

	export type OrderStage = (typeof ORDERS_STAGE)[keyof typeof ORDERS_STAGE];

	type DeepMerge<T, U> = {
		[K in keyof T]: K extends keyof U
			? U[K] extends object
				? T[K] extends object
					? DeepMerge<T[K], U[K]>
					: U[K]
				: U[K]
			: T[K];
	};

	export type ModelSimpleForTable = DeepMerge<
		Partial<Model>,
		{
			createdAt: string;
			isPreliminary: boolean;
			orderDate: string;
			filledAt?: string;
			executorToOrder?: Array<{
				executor?: {
					id?: string;
					callSign?: string;
					online?: boolean;
					taxiService?: {
						id?: string;
						settlement?: Record<string, string>;
						company?: { name?: Record<string, string> };
					};
				};
				additionalFields?: {
					arrivalTime?: number;
					acceptedByDispatcher?: { active?: boolean };
				};
			}>;
			additionalFields: {
				transfer?: {
					lastReceivedOrder?: {
						isPreliminary: boolean;
						executorToOrder?: Array<{
							executor?: {
								id?: string;
								callSign?: string;
								online?: boolean;
								taxiService?: {
									id?: string;
									settlement?: Record<string, string>;
									company?: { name?: Record<string, string> };
								};
							};
							additionalFields?: {
								arrivalTime?: number;
								acceptedByDispatcher?: { active?: boolean };
							};
						}>;
						offer?: {
							executor?: {
								id?: string;
								callSign?: string;
								online?: boolean;
							};
						};
						orderDate?: string;
						filledAt?: string;
						closedOrderComments?: Array<{
							status?: string;
							dispatcher?: { callSign?: string };
							executor?: { callSign?: string };
							customer?: unknown;
						}>;
						phones?: Array<{ number?: string }>;
						taxiService?: {
							id?: string;
							settlement?: Record<string, string>;
							company?: { name?: Record<string, string> };
						};
					} | null;
					offer?: {
						executor?: {
							id?: string;
							callSign?: string;
							online?: boolean;
						};
					};
					sendProcess?: { currentTransferStage?: string };
				};
				customerNotes?: string;
				executorNotes?: string;
				discount?: { active?: boolean };
				waitingTimeMilliseconds?: number;
				idleTimeMilliseconds?: number;
				displaySettings?: { showCustomerPhone?: boolean };
				taximeter?: boolean;
				rateSettings?: Record<string, boolean>;
				initiator?: { callSign?: string };
				transportationType?: string;
			};
			isOwn?: boolean;
			offer?: {
				executor?: { id?: string; callSign?: string; online?: boolean };
				/** абсолютный дедлайн предложения, ms (часы сервера) */
				orderOfferTime?: number;
				/** часы сервера в момент отправки снапшота */
				serverTime?: number;
			};
			executorReminderStatus?: { status?: string };
			executorCallStatus?: {
				status?: "need_call" | "called" | "calling" | "none" | string;
				metadata?: { callerCallSign?: string };
				user?: { data?: { callSign?: string } };
			};
			phones?: Array<{ group?: number; number?: string }>;
			orderToCarClasses?: Array<{
				carClass?: { name?: Record<string, string> };
			}>;
			closedOrderComments?: Array<{
				status?: string;
				dispatcher?: { callSign?: string };
				executor?: { callSign?: string };
				customer?: unknown;
			}>;
			taxiService?: {
				company?: { name?: Record<string, string> };
				settlement?: Record<string, string>;
			};
			counterparty?: { additionalFields?: { name?: string } };
			checkCard?: {
				code?: { value?: string };
				check?: { additionalFields?: { checkValue?: string } };
			};
			passengers?: Array<{
				customer?: {
					person?: {
						name?: string;
						surname?: string;
						fatherName?: string;
					};
					rideNumber?: number;
					counters?: { total?: number };
				};
			}>;
			type?: string;
			billingCustomer?: {
				person?: {
					name?: string;
					surname?: string;
					fatherName?: string;
				};
			};
			orderNote?: string;
			points?: Array<{
				address?: string;
				sector?: { name?: Record<string, string> };
				settlement?: string;
			}>;
			orderToServices?: Array<{
				service?: { name?: Record<string, string> };
			}>;
			smsMessages?: Array<{ action?: string | number; status?: string }>;
			source?: string;
			cost: {
				value: number;
				currency?: { settings?: { name?: string } };
				settings?: {
					customerDiscountPlans?: Array<{
						type?: "main" | "additional" | string;
						name?: Record<string, string>;
						active?: boolean;
						conciseSettings?: {
							discount?: { unit?: string; value?: number };
							maxDiscount?: { active?: boolean; value?: number };
						};
					}>;
					currency?: { settings?: { name?: string } };
					rounding?: {
						multiple: { value?: number; active?: boolean };
						method?: string;
						precision?: number;
					};
				};
			};
			executingStages?: {
				accepted?: { timestamp?: number };
				arrived?: { timestamp?: number };
				with_clients?: { timestamp?: number };
				assigned?: boolean;
				delayed?: { data?: { delay?: number } };
			};
			executingStage?: string;
			downtimes?: { waitingClient?: number; withClients?: number };
			id?: string | number;
			orderNumber?: string | number;
			paymentType: string;
			paymentStatus?: { status?: string };
			status?: string;
			highlighting?: { type?: string; color?: string };
			park_line?: string | number;
			rate?: { name?: Record<string, string> };

			cellsForTable?: CellsForTable;
			cellsForTableSettings?: CellsForTableSettings;
		}
	>;

	export interface Model {
		id: number;
		transfer?: any;

		checkCard: Record<string, any> | null;
		counterparty: Record<string, any> | null;
		park_line: number | null;
		v: number;
		index: number;
		type: OrderType;
		stage?: OrderStage;
		status: OrderStatus;
		source: OrderSource;

		executingStage: OrderExecutingStage;
		executingStages?: Record<ExecuteOrderStage, any> | null;
		executingStageUpdatedAt: string;
		executorCallStatus?: any | null;
		executorReminderStatus?: any | null;
		/**
		 * ```ts
		 *
		 * acceptedByDispatcher: {
			active: !options.dispatcherId;
			dispatcherId: options.dispatcherId;
		};
		 * ```
		 */
		executorToOrder: any[] | null;
		carToOrder: any[] | null;

		externalPaymentTransactions?: any | null;

		customerCallStatus?: any;

		orderNumber: number;
		cost: OrderCost;
		paymentType: PaymentType;
		paymentStatus: {
			status: OrderPaymentStatus;
			timestamp: number;
		} | null;
		taxiService: any;
		sectors: {
			point: LatLngLiteral;
		};
		phones: Phone[];
		orderNote: string;
		isPreliminary: boolean;
		isCustomerDiscounted: boolean;
		isManualBroadcasting: boolean;
		closedOrderComments: any[];

		orderToCarClasses: any[];
		orderToServices: any[];

		offer?: any;
		route?: {
			distance: number;
			points: LatLngLiteral[];
			sectors: any[];
			segments: LatLngLiteral[][];
		};
		points: IOrderPoint[];
		passengers: Passanger[];
		position: string;

		billingCustomer?: Customer;

		additionalFields: Order.IAdditionalFields;

		rate: Record<string, any> & { id: number };

		orderDate: string;
		updatedAt: string;
		createdAt: string;
		closedAt: string;
		filled?: boolean;
		filledAt?: string | null;
		revertedAt?: string | null;
		expiredAt?: string | null;
		// deletedAt: string | null;
		smsMessages: IOrderSMSMessage[];
		receipt?: ReceiptSummary | null;

		agent?: Agent.Model;
		agentReward?: any;

		highlighting?: any;

		// transfer
		/** Order id in Global order Transfer System */
		globalId?: string;
		/** Indicates whether the order is internal or not. */
		isOwn?: boolean;

		moveToProgress?: MoveOrderToProgress;

		downtimes: any;

		cellsForTable?: CellsForTable;
		cellsForTableSettings?: CellsForTableSettings;
		__isPadding: any;
	}

	export type CellsForTable = Partial<Record<ColumnId, any>>;

	export type CellsForTableSettings = {
		isCellsReady: boolean;
		lang?: ValueLanguage;
		colors?: ColorState;
		orderSettings?: OrderSettingNameSpace.OrderSettings;
		// dateFns?: DateFns;
	};

	export interface Pagination {
		count: number;
		offset: number;
	}

	export interface ResponseGetByTab {
		items: Model[];
		pagination: Pagination;
	}

	export type OrderTab =
		| "all"
		| "live"
		| "overall"
		| "preliminary"
		| "executable"
		| "closed"
		| "own_closed"
		| "own";

	export interface MoveOrderToProgress {
		value: boolean;
		autoTime: number;
		type: MoveToProgressType;
		orderId?: number;
	}

	export type Type =
		| "overall"
		| "all"
		| "live"
		| "executable"
		| "preliminary"
		| "closed"
		| "own"
		| "own_closed";

	type SortingKey =
		| "orderDate"
		| "orderTime"
		| "executorArrivalDate"
		| "executorArrivalTime"
		| "timeToDelivery"
		| "executorCallSign"
		| "pickupSettlement"
		| "pickupAddress"
		| "pickupSector"
		| "phone"
		| "customerCallStatus"
		| "executorCallStatus"
		| "orderNumber"
		| "executingStageWithClientsTime"
		| "customerNote"
		| "carClass"
		| "destinationSettlement"
		| "destinationAddress"
		| "destinationSector"
		| "paymentType"
		| "executorNote"
		| "dispatcherCallSign"
		| "additionalPhone"
		| "status"
		| "source"
		| "executingStage"
		| "closeReason"
		| "rideNumber"
		| "totalRideCount"
		| "createOrderDate"
		| "createOrderTime"
		| "customerFullName"
		| "executorLate"
		| "executingStageAcceptedTime"
		| "executingStageArrivedTime"
		| "executingStageWaitingCustomerTime"
		| "smsLateStatus"
		| "smsWillBeAtStatus"
		| "smsCarNotFoundStatus"
		| "smsAwaitingPassengersStatus"
		| "smsWithPassengersStatus"
		| "smsOrderCompletedStatus"
		| "smsExecutorSwitchedStatus"
		| "counterparty"
		| "counterpartyCheck"
		| "counterpartyCheckCard"
		| "company"
		| "taxiService"
		| "idleTime"
		| "rate"
		| "services"
		| "parameters"
		| "discount"
		| "transportationType";

	export interface SubscribeOptions
		extends Omit<ServiceSubscribeOptionsBase<Order.Model>, "order"> {
		order?: Order;

		tab?: Type;
		customerIds?: number[];
		executorIds?: number[];
		taxiServiceIds?: number[];
		counterpartyIds?: ModelId[];
		checkIds?: ModelId[];
		checkCardIds?: ModelId[];
		employeeIds?: ModelId[];
		hasCounterparty?: boolean;
		hasEmployee?: boolean;
		agentIds?: ModelId[];
		dateRange?: {
			from: Date;
			to: Date;
		};

		dispatcherIds?: number[];

		hasExecutor?: boolean;

		customerPhones?: string[];
		executorCallSigns?: string[];
		carCallSigns?: string[];
		carRegistrationNumbers?: string[];

		pickupAddress?: string;
		destinationAddress?: string;

		lang?: string;
		sanitizeType?: string;
		withoutRoute?: boolean;
		/** Inactive /orders tabs: keep the socket for the badge, drop the row window. */
		countOnly?: boolean;

		// language?: MapLanguage;
		// status?: OrderStatus;
	}

	export type Order = Partial<Record<SortingKey, SortingOrder>>;

	export interface SharedOptions {
		deprecate?: boolean;
	}

	export interface StoreOptions extends SharedOptions {}
	export interface UpdateOptions extends SharedOptions {}
	export interface DestroyOptions extends SharedOptions {}

	export interface CopyOptions {
		amount: number;
		type?: "all-points" | "without-points" | "first-points";
		pointsAmount: number;
	}

	export interface CloseOptions {
		status?: string;
		subStatus?: string;
		/** Причина отказа клиента из справочника. */
		clientRefusalReasonId?: number;
		comment?: string;
		update?: boolean;
		processedByTaximeter?: boolean;
		timeoutForTaximeter?: number;
		/** Archive-edit "Save" on a cash order: skip settling the price
		 * delta on the customer's MAIN balance (e.g. the pre-edit price
		 * was itself wrong, not something the customer actually paid). */
		skipArchiveEditBalanceDelta?: boolean;
	}

	export interface AssignOptions {
		executorId: number;
		arrivalTime?: number;
	}

	export interface AcceptOptions {
		arrivalTime?: number;
	}

	export interface RecalculateOptions {
		useActualRates?: boolean;
	}

	export interface RefuseOptions {
		reason: "accidentally" | "decline_by_client";
	}

	export interface UpdateCallStatusOptions {
		type: "executor" | "customer";
		status: "need_call" | "calling" | "called" | "none";
	}

	export namespace Model {
		export interface OrderForm {
			orderId: number;
			/** this orderFormTab.form as `JSON.stringify` */
			form: string | null;
		}

		export type New = Omit<
			Model,
			"id" | "createdAt" | "updatedAt" | "deletedAt"
		>;

		export interface Modified {
			id: Order.Model["id"];
			additionalFields?: Partial<Order.IAdditionalFields> | null;
			orderNote?: Order.Model["orderNote"];
			orderDate?: Date;
			isPreliminary?: boolean;
			taxiServiceId?: number;
			counterpartyId?: number;
			checkCardId?: number;
			rateId?: number;
			carClassIds?: number[];
			serviceIds?: number[];
			phones?: Phone[];
			passengers?: Order.Model["passengers"];
		}
	}
}

export default Order;
